<template>
  <div class="wrapper-spinner">
    <v-progress-circular :size="79" :width="7" color="#00000" indeterminate></v-progress-circular>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.wrapper-spinner {
  top: 0;
  z-index: 911;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>